import React, { useState, useRef }  from 'react';

const ConfirmPopup = ({myRef}) => {
  const [internal, setInternal] = useState({});
  const modalRef = useRef();
  const onClick = () => {};
  const hide = (e) => { e.preventDefault(); modalRef.current.style.display = "none"; }
  const show = () => { modalRef.current.style.display = "block"; }

  myRef.current = {
    internal: {
      modalRef: modalRef,
      onClick: onClick,
      question: '',
      confirmLabel: undefined,
      danger: false,
      hide: hide,
      show: show,
    },
    setInternal: setInternal
  }

  // Callers may pass a confirm label and mark the action destructive (via AskConfirm's options); the
  // default is the neutral "OK" primary button, so existing callers are unchanged.
  const confirmLabel = internal.confirmLabel || t('quote_builder.ok');
  const confirmClass = `dct-button ${internal.danger ? 'dct-button--danger' : 'dct-button--primary'}`;

  return (
    <div className="modal" ref={modalRef} >
      <div className="modal-content confirm-popup">
        <span className="close" onClick={hide} >&times;</span>
        <div className="confirm-popup__question"> <strong> {internal.question} </strong> </div>
        <div className="confirm-popup__actions">
          <button type="button" onClick={hide} className="dct-button dct-button--secondary"> {t('quote_builder.cancel')} </button>
          <button type="button" onClick={internal.onClick} className={confirmClass}> {confirmLabel} </button>
        </div>
      </div>
    </div>
  )
}

const AskConfirm = (myRef, question, onConfirm, args, options = {}) => {
  myRef.current.internal.show();

  myRef.current.setInternal((previous) => {
    previous['question'] = question;
    previous['confirmLabel'] = options.confirmLabel;
    previous['danger'] = options.danger || false;
    previous['onClick'] = (e) => {
      e.preventDefault();
      onConfirm(args, myRef.current.internal.hide(e))
    };
    return { ...previous };
  });

}

export {
  AskConfirm,
  ConfirmPopup,
};
